<template>
  <div class="tabNav">
    <div class="tab-item" :class="{active:values == item.value}" v-for="(item,index) in list" :key="index"
      @click="change(item)">
      {{ item.label }}
      <span id="" class="text-red" v-if="type=='order'&&item.order_number>0">
        ({{item.order_number}})
      </span>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'tavNav',
    props: {
      values: {
        type: String | Number,
        default: ''
      },
      type: {
        type: String | Number,
        default: ''
      },
      list: {
        type: Array,
        default: () => {
          return []
        }
      }
    },
    model: {
      prop: 'values',
      event: 'change'
    },
    watch:{
      values: {
      	handler(newVal, oldVal) {
      		console.log('value：',newVal,oldVal);
      	},
      	immediate: true
      }
     
    },
    mounted() {
      console.log(this.values,this.list,'values111');
    	// 隐藏显示之后触发
    	// if (this.list.length > 0) {
    		
    	// 	let currentStatus = this.list.findIndex(item => item[currentKey] == this.current);
    	// 	this.values = currentStatus > -1 ? currentStatus : 0;
    		
    	// }
    },
    data() {
      return {}
    },
    
    methods: {
      change(obj) {
        if (this.values === obj.value) return false
        this.$emit('change', obj.value)
      }
    }
  }
</script>

<style scoped lang="less">
  .tabNav {
    //max-width: 600px;
    user-select: none;

    .tab-item {
      display: inline-block;
      margin-right: 8px;
      height: 35px;
      padding: 0 15px;
      cursor: pointer;
      background-color: #f7f8fa;
      border-radius: 9px;
      border: none;
      color: rgb(17, 17, 17);
      font-size: 12px;
      line-height: 35px;
    }

    .active {
      color: #FB9E2F;
      font-weight: 500;
      position: relative;

      &::after {
        content: '';
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        border: 1px solid #FB9E2F;
        border-radius: 9px;
      }
    }
  }
</style>
